/// <reference types="vite/client" />

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001').replace(/\/$/, '');

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function isTrustedApiOrigin(origin: string): boolean {
  try {
    return new URL(API_BASE_URL).origin === origin || window.location.origin === origin;
  } catch {
    return window.location.origin === origin;
  }
}
